module.exports = __webpack_public_path__ + "assets/img/00043.634508e1.png";